export default __webpack_public_path__ + "static/media/vid-02.bf6d9713.mp4";